<template>
  <div class="page">
    <Panel lineColor="var(--primary-color)">
      <template v-slot:options>
        <FormButtonGroup align="end" spaced>
          <FormButton text="Nova novidade" type="primario" @click="onNew" />
        </FormButtonGroup>
      </template>
      <DataTable
        :headers="headers"
        :endpoint="endpoint"
        sortBy="resumo"
        :sortDesc="false"
        ref="datatable"
        search
        @click="onClick"
        :limitPage="[10, 25, 50, 100, 150]"
      >
        <template v-slot:resumo="{ row }">
          <h4>{{ validarFrase(row.descricao) }}</h4>
          {{ validarFrase(row.resumo) }}
        </template>
        <template v-slot:data_publicacao="{ col }">
          {{ col | formatDate }}
        </template>
        <template v-slot:palavras_chave="{ col }">
          <span v-if="col.length > 0">
            <Chip v-for="(pc, i) in col" :key="i" color="primario" :text="pc" />
          </span>
          <span v-else></span>
        </template>
        <template v-slot:idnovidade="{ row }">
          <FormButtonMenu
            icon
            :options="tableOptions"
            :loading="loadingRow[row.idnovidade]"
            @click="op => selectOption(row, op)"
          >
            <v-icon size="15">fas fa-ellipsis-v</v-icon>
          </FormButtonMenu>
        </template>
      </DataTable>
    </Panel>
    <transition name="slide-popup" mode="out-in">
      <router-view class="view" @close="onClose"></router-view>
    </transition>
  </div>
</template>

<script>
import DataTable from "@/components/DataTable";
import Panel from "@/components/Panel";
import FormButtonMenu from "@/components/form/FormButtonMenu";
import FormButton from "@/components/form/FormButton";
import FormButtonGroup from "@/components/form/FormButtonGroup";
import Chip from "@/components/Chip.vue";
import { NOVIDADE_DELETE } from "@/store/actions/novidade";

export default {
  name: "NovidadeAdmin",
  components: {
    DataTable,
    Panel,
    FormButtonMenu,
    FormButton,
    FormButtonGroup,
    Chip
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: "Resumo", value: "resumo" },
      { text: "Data de publicação", value: "data_publicacao", align: "center" },
      { text: "Palavras-chaves", value: "palavras_chave", align: "center" },
      { text: "Opções", value: "idnovidade", clickable: false }
    ],
    tableOptions: [
      { text: "Deletar", value: "delete" },
      { text: "Editar", value: "update" }
    ],
    loadingRow: {}
  }),
  computed: {
    endpoint() {
      return `/api/v4/novidades/datatable`;
    }
  },
  methods: {
    onClose() {
      this.dialog = false;
      this.$refs.datatable.reload();
      this.loadingRow = {};
    },
    onClick(item) {
      this.$router.push(`/admin/novidades/${item.idnovidade}`);
    },
    onNew() {
      this.$router.push("novidades/novo");
    },
    selectOption(item, option) {
      switch (option.value) {
        case "delete":
          return this.onDelete(item);
        case "update":
          return this.onClick(item);
      }
    },
    onDelete(item) {
      const options = {
        text: "Essa ação é irreversível.",
        title: `Você confirma a exclusão da novidade '${item.descricao}'?`
      };
      this.confirmSwal(options, () => this.delete(item));
    },
    delete(item) {
      this.loadingRow = {
        ...this.loadingRow,
        [item.idnovidade]: true
      };
      this.$store
        .dispatch(NOVIDADE_DELETE, item.idnovidade)
        .then(() => {
          this.$vueOnToast.pop("success", "Novidade removida com sucesso");
          this.$refs.datatable.reload();
          this.loadingRow = {
            ...this.loadingRow,
            [item.idnovidade]: false
          };
        })
        .catch(err => {
          const erro =
            err.response.data.Mensagem ||
            err.response.data ||
            "Falha ao excluir novidade";
          this.$vueOnToast.pop("error", erro);
          this.loadingRow = {
            ...this.loadingRow,
            [item.idnovidade]: false
          };
        });
    },
    validarFrase(frase) {
      const maxLength = 50;
      if (frase.length > maxLength) {
        return frase.slice(0, maxLength) + "...";
      }
      return frase;
    }
  }
};
</script>
